import React, { useContext, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useImpression, ImpressionProvider } from '@thd-olt-component-react/impression';
import { initSurvey } from '../qualtricsHelper';
import './search-feedback.scss';

const SearchFeedbackComponent = ({ 
  type = 'search', 
  impressionID = null 
}) => {
  const { channel } = useContext(ExperienceContext);

  const { ref, clickID } = useImpression({
    data: {
      id: impressionID || 'SearchFeedbackID',
      name: 'SearchFeedback',
      component: 'SearchFeedback',
      position: 1,
      type: 'content'
    }
  });

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('search-feedback.ready');
    initSurvey();
  }, []);

  if (channel === 'mobile') return null;

  const rowClasses = classNames({
    collectionFeedbackWrapper: type === 'collection'
  });

  const columnClasses = classNames({
    'article-feedback-wrapper': type === 'articles',
    'search-feedback-wrapper': type !== 'articles'
  });

  return (
    <div
      className="sui-grid"
      ref={ref}
      // eslint-disable-next-line react/no-unknown-property
      clickid={clickID}
    >
      <div
        className={rowClasses}
        data-component="SearchFeedback"
      >
        <div className={columnClasses}>
          <div id={`${type}Feedback`} />
        </div>
      </div>
    </div>
  );
};

SearchFeedbackComponent.displayName = 'SearchFeedbackComponent';

SearchFeedbackComponent.propTypes = {
  type: PropTypes.oneOf([
    'articles',
    'search',
    'collection'
  ]),
  impressionID: PropTypes.string
};

const SearchFeedback = ({ 
  type = 'search', 
  impressionID = null, 
  data = null, 
  ...restProps 
}) => {
  const fallbackData = {
    id: impressionID || 'SearchFeedbackID',
    component: 'SearchFeedback',
    name: 'SearchFeedback',
    type: 'content'
  };

  const impressionData = data || fallbackData;

  return (
    <ImpressionProvider
      key="SearchFeedback"
      data={impressionData}
    >
      <SearchFeedbackComponent
        type={type}
        impressionID={impressionID}
      />
    </ImpressionProvider>
  );
};

SearchFeedback.displayName = 'SearchFeedback';

SearchFeedback.propTypes = {
  type: PropTypes.oneOf([
    'articles',
    'search',
    'collection'
  ]),
  impressionID: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.string,
    component: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string
  })
};

export { SearchFeedback };
